// Coverage counts for copy, e.g. `${COVERAGE.chains} chains`.
// Builds overwrite this file with tooling/coverage-stats/refresh.mts. The committed
// values are the fallback: 127 chains, 1,638 apps, 15,059 tokenized assets.
export const COVERAGE = {
  chains: "100+",
  apps: "1,600+",
  tokenizedAssets: "15,000+",
} as const
